<template>
  <div v-if="!appUser">
    <v-snackbar v-model="showsnackbar" color="black" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex lg10>
        <v-form ref="form" v-model="valid" lazy-validation> 
          <v-layout wrap justify-center>
            <v-flex align-self-center text-center lg1 md1 sm2 xs3 pt-lg-5 pl-3 pl-sm-5 >
              <v-img
                :src="require('../../assets/kurma-logo.png')"
                contain
                width="80px"
                height="80px"
              ></v-img>
            </v-flex>
            <v-flex pt-lg-5 xs12 align-self-center text-center>
              <span class="welcome"><b> Welcome Back</b></span>
            </v-flex>
            <v-flex pb-lg-5 xs12 align-self-center text-center py-2>
              <span class="welcome2">sign In to Continue</span>
            </v-flex>
          </v-layout>
          <v-layout wrap justify-center>
            <v-flex align-self-center lg5 md6 sm7 xs11>
              <v-text-field
                class="logregcolorfontwhite"
                outlined
                dense
                v-model="uname"
                :rules="[rules.required]"
                label="Username"
                required
                prepend-inner-icon="mdi-keyboard"
              ></v-text-field>

              <v-text-field
                outlined
                dense
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="[passwordRules.required,passwordRules.min]"
                :type="showPassword ? 'text' : 'password'"
                v-model="password"
                name="input-10-2"
                label="Password"
                class="input-group--focused logregcolorfontwhite"
                @click:append="showPassword = !showPassword"
                prepend-inner-icon="mdi-lock"
              ></v-text-field>

              <v-layout wrap justify-end>
                <v-flex pb-10 align-self-end text-right>
                  <router-link
                    class="routerlink"
                    :to="{ name: 'forgotPassword' }"
                    ><span class="logregcolorfont"
                      >Forgot Password ?</span
                    ></router-link
                  >
                </v-flex>
              </v-layout>
                

              <v-btn
                class="logregcolorfontwhite"
                :disabled="!valid"
                color="success"
                width="100%"
                @click="login"
              >
                Login
              </v-btn>

              <v-layout wrap justify-center py-md-3 py-lg-0 py-sm-3 py-2>
                <v-flex py-lg-8 align-self-center>
                  <span class="logregcolorfontblack"
                    >Don't have account!
                    <router-link class="routerlink" :to="{ name: 'register' }"
                      ><span class="logregcolorfont"
                        >Register</span
                      ></router-link
                    ></span
                  >
                </v-flex>
              </v-layout>
               <v-layout wrap justify-center text-center>
                    <v-flex xs12 style="color:red" pb-2>
                    {{warning}}
                    </v-flex>
                 </v-layout>
            </v-flex>
          </v-layout>
        </v-form>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
import store from "./../../store";
export default {
  data: () => ({
    warning:"",
    userData: [],
    layout: "one",
    valid: true,
    name: "",
    showsnackbar: false,
    msg: null,
    showPassword: false,
    password: "",
    passwordRules: {
      required: (value) => !!value || "Required.",
      min: (v) => v.length >= 8 || "Min 8 characters",
    },
    email: "",
    uname: "",
    // emailRules: [
    //   (v) => !!v || "E-mail is required",
    //   (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    // ],
    rules: {
      required: (value) => !!value || "Required.",
      counter: (value) => value.length <= 20 || "Max 20 characters",
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
      },
    },
    select: null,
    checkbox: false,
  }),
  computed: {
    appUser() {
      return store.state.isLoggedIn;
    },
  },
  methods: {
    // redirectto(){
    //   if(this.appUser){
    //      this.$route.push('/Profie')
    //   }
    // },
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    login() {
      if (this.$refs.form.validate()) {
        axios({
          method: "POST",
          url: "user/login",
          data: {
            username: this.uname,
            password: this.password,
          },
        })
          .then((response) => {
            if (response.data.data.token) {
              localStorage.setItem("token", response.data.data.token);
              store.commit("loginUser", response.data.status);
              store.commit("userData", response.data.data);
              this.$router.push("/");
            } else {
              this.msg = response.data.msg;
              this.showsnackbar = true;
            }
          })
          .catch((err) => {
            console.log(err);
            this.warning = "The username or password was incorrect...!"
          });
      }
    },
  },
};
</script>